import { type FullAirHandlerUnit } from "@eisox/api/core-api";

import type { Place } from "~/features/planning";

import { getFullAirHandlerUnitsByGroup } from "./group.helper";

export const airHandlerUnitsToPlaces = (airHandlerUnits: FullAirHandlerUnit[]): Place[] => {
  const airHandlerUnitsByGroup = getFullAirHandlerUnitsByGroup(airHandlerUnits);
  return Object.values(airHandlerUnitsByGroup).flatMap(value => {
    const first = value[0];
    if (!first) return [];
    return [
      {
        id: value.map(ahu => ahu.id).join("-"),
        name: value.length > 1 ? (first.group ?? first.name) : first.name,
        parentIds: value.map(ahu => ahu.id),
      },
    ];
  });
};
